module.exports = __webpack_public_path__ + "d07060c2e6c20a8acf85b2949b201425.jpg";